let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("5soZa")).then(() => parcelRequire('9CRO6'));